import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { AppConstant, LangConstant } from "const";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import ConversationRedux from "redux-store/conversation.redux";
import { handleSendNotiInSaga } from "utils";

const EditPortManagement = ({ open, onClose, dataEdit }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const getPortManager = useSelector(state => state.conversationRedux.getPortManager);
  const updateHarborShip = useSelector(state => state.conversationRedux.updateHarborShip);

  const [selectPortManager, setSelectPortManager] = useState("1fa67aa1625740b8b21651aab356581c");
  const [phoneNumber, setPhoneNumber] = useState(dataEdit?.phone_number);

  const [valueInput, setValueInput] = useState({
    portName: dataEdit?.name,
    numberOfBridges: dataEdit?.quay_number,
    DWT: "",
    height: dataEdit?.quay_length,
    minimumDepth: dataEdit?.depth_min,
    maximumFlowDepth: dataEdit?.depth_max,
    longStream: dataEdit?.length,
    wattage: dataEdit?.power,
    warehouseArea: dataEdit?.square,
    companyName: dataEdit?.company_name,
    address: dataEdit?.address,
    numberFax: dataEdit?.fax,
    latitude: dataEdit?.latitude,
    longitude: dataEdit?.longitude,
  });

  const onClickAddPort = () => {
    if (selectPortManager) {
      dispatch(
        ConversationRedux.updateHarborShip({
          uid: dataEdit.uid,
          address: valueInput.address,
          capacity: +valueInput.warehouseArea,
          company_name: valueInput.companyName,
          country_code: "VN",
          fax: valueInput.numberFax,
          latitude: +valueInput.latitude,
          longitude: +valueInput.longitude,
          name: valueInput.portName,
          phone_number: phoneNumber,
          square: valueInput.warehouseArea,
          power: valueInput.wattage,
          quay_number: +valueInput.numberOfBridges,
          quay_length: +valueInput.height,
          length: +valueInput.longStream,
          depth_max: +valueInput.maximumFlowDepth,
          depth_min: +valueInput.minimumDepth,
          source_type: 4,
          port_uid: selectPortManager,
          status: 0,
        }),
      );
    }
  };

  const onChangeInput = e => {
    setValueInput({ ...valueInput, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setPhoneNumber(dataEdit?.phone_number);
  }, [dataEdit?.phone_number]);

  useEffect(() => {
    setValueInput({
      portName: dataEdit?.name,
      numberOfBridges: dataEdit?.quay_number,
      DWT: "",
      height: dataEdit?.quay_length,
      minimumDepth: dataEdit?.depth_min,
      maximumFlowDepth: dataEdit?.depth_max,
      longStream: dataEdit?.length,
      wattage: dataEdit?.power,
      warehouseArea: dataEdit?.square,
      companyName: dataEdit?.company_name,
      address: dataEdit?.address,
      numberFax: dataEdit?.fax,
      latitude: dataEdit?.latitude,
      longitude: dataEdit?.longitude,
    });
  }, [
    dataEdit?.address,
    dataEdit?.company_name,
    dataEdit?.depth_max,
    dataEdit?.depth_min,
    dataEdit?.fax,
    dataEdit?.latitude,
    dataEdit?.length,
    dataEdit?.longitude,
    dataEdit?.name,
    dataEdit?.power,
    dataEdit?.quay_length,
    dataEdit?.quay_number,
    dataEdit?.square,
  ]);

  useEffect(() => {
    const filters = getPortManager && getPortManager?.filter(item => item?.name === dataEdit?.port_name);
    filters && filters?.forEach(item2 => setSelectPortManager(item2.uid));
  }, [dataEdit?.port_name, getPortManager]);

  useEffect(() => {
    if (updateHarborShip) {
      handleSendNotiInSaga(LangConstant.MS_UPDATE_SUCCESS, "success");
      onClose();
    }
    dispatch(
      ConversationRedux.conversationSet({
        updateHarborShip: false,
      }),
    );
  }, [updateHarborShip]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{LangConstant.TXT_EDIT_INFOMATION}</DialogTitle>
      <DialogContent>
        <DialogContent>
          <Box className={classes.paddingInput}></Box>
          <Box className={classes.paddingTopSelect}>
            <FormControl size="small" fullWidth>
              <InputLabel id="demo-simple-select-label">Chọn cảng biển</InputLabel>
              <Select
                onChange={e => setSelectPortManager(e.target.value)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Chọn cảng biển"
                value={selectPortManager}
              >
                {getPortManager &&
                  getPortManager.map(item => (
                    <MenuItem key={item.uid} value={item.uid}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>

          <Typography>{LangConstant.TXT_INFORMATION}</Typography>
          <TextField
            onChange={onChangeInput}
            name="numberOfBridges"
            type="number"
            size="small"
            fullWidth
            label={LangConstant.L_NUMBER_OF_DEMAND}
            variant="outlined"
            defaultValue={dataEdit?.quay_number}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              name="DWT"
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_DWT}
              variant="outlined"
            />
          </Box>
          <TextField
            onChange={onChangeInput}
            name="height"
            type="number"
            size="small"
            fullWidth
            label={LangConstant.L_HEIGHT}
            variant="outlined"
            defaultValue={dataEdit?.quay_length}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_MINIMUM_DEPTH}
              variant="outlined"
              name="minimumDepth"
              defaultValue={dataEdit?.depth_min}
            />
          </Box>
          <TextField
            onChange={onChangeInput}
            name="maximumFlowDepth"
            type="number"
            size="small"
            fullWidth
            label={LangConstant.L_MAXMUM_FLOW_DEPTH}
            variant="outlined"
            defaultValue={dataEdit?.depth_max}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              name="longStream"
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_LONG_STREAM}
              variant="outlined"
              defaultValue={dataEdit?.length}
            />
          </Box>
          <TextField
            onChange={onChangeInput}
            name="wattage"
            type="number"
            size="small"
            fullWidth
            label={LangConstant.L_POWER}
            variant="outlined"
            defaultValue={dataEdit?.power}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_SQUARE}
              variant="outlined"
              name="warehouseArea"
              defaultValue={dataEdit?.square}
            />
          </Box>
          <TextField
            onChange={onChangeInput}
            name="companyName"
            size="small"
            fullWidth
            label={LangConstant.L_COMPANY_NAME}
            variant="outlined"
            defaultValue={dataEdit?.company_name}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              name="address"
              size="small"
              fullWidth
              label={LangConstant.L_ADDRESS}
              variant="outlined"
              defaultValue={dataEdit?.address}
            />
          </Box>
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              name="numberFax"
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_FAX}
              variant="outlined"
              defaultValue={dataEdit?.fax}
            />
          </Box>
          <PhoneInput
            value={phoneNumber}
            onChange={phone => setPhoneNumber(phone)}
            country="vn"
            onlyCountries={AppConstant.COUNTRY}
            defaultValue={dataEdit?.phone_number}
          />
          <Box className={classes.paddingInput}>
            <TextField
              onChange={onChangeInput}
              name="longitude"
              type="number"
              size="small"
              fullWidth
              label={LangConstant.L_LONGITUDE}
              variant="outlined"
              defaultValue={dataEdit?.longitude}
            />
          </Box>
          <TextField
            onChange={onChangeInput}
            name="latitude"
            type="number"
            size="small"
            fullWidth
            label={LangConstant.L_LANGITUDE}
            variant="outlined"
            defaultValue={dataEdit?.latitude}
          />
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClickAddPort}>{LangConstant.TXT_BUTTON_ADD}</Button>
        <Button onClick={onClose}>{LangConstant.TXT_BUTTON_CANCEL}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPortManagement;

const useStyles = makeStyles(theme => ({
  paddingInput: {
    padding: "10px 0",
  },
  paddingTopSelect: {
    paddingTop: 10,
  },
}));
